import { AspectRatio } from '@mantine/core';
import { useSelector } from "react-redux";

/**
 * Renders a document viewer for a specific resource ID.
 *
 * @param {Object} props - The component props.
 * @param {string} props.resourceId - The ID of the resource to display.
 * @return {JSX.Element} The document viewer component.
 */

const UserShowDoc = (props:any ) => {
    const showdocs = useSelector((state: any) => state.user.meetingdocs)

    //console.log("showdocs in UserShowDoc:",showdocs)
    //console.log("props.resourceId:",props.resourceId)

    let doclink = showdocs.filter((obj: { resourceId: any }) => {
        return obj.resourceId === props.resourceId
      });

    let docurl = doclink[0].viewerIFrameUrl

    
   
    return (
        <>
          <AspectRatio ratio={16 / 9} sx={{ maxWidth: 1920 }} mx="auto">
            <iframe
                key={docurl}
                src={docurl}
                title={"Testraum"}
                allow="camera;microphone;display-capture"
                allowFullScreen
                frameBorder= "0"
              />
          </AspectRatio>
        </>
    )
};

export default UserShowDoc;